
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface ErrorAlertProps {
  error: string;
  details?: string | null;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ error, details }) => {
  if (!error) return null;
  
  return (
    <Alert variant="destructive" className="mb-4">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Error</AlertTitle>
      <AlertDescription className="whitespace-pre-wrap break-words">{error}</AlertDescription>
      {details && (
        <div className="mt-2 text-xs opacity-80 overflow-auto max-h-32">
          {details}
        </div>
      )}
    </Alert>
  );
};
